import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';

import './AddMasterReading.css';
import {
  availableEmployeeSessions,
  cancelSession,
  endSession,
  getPrevInAndOut,
  getSessionReading,
  listMachine,
  listReport,
  loadStartedSession,
  openLastSessionReading,
  resetReading,
  startSession,
  updateReading,
  listDeletedReadingSessions,
  restoreReadingSession,
  deleteForeverReadingSession,
  listManageBonus,
  listCategory,
} from '../../../redux/actions/settings';
import withShipment from '../../../withShipment';
import {
  userInfoSelector,
  employeesSelector,
} from '../../../redux/selectors/auth';
import { getEmployees } from '../../../redux/actions/auth';
import { listAllCustomers } from '../../../redux/actions/customer';
import { customersSelector } from '../../../redux/selectors/customer';
import {
  loadSessionReports,
  clearSessionReports,
  submitBonusDecision,
  editBonusV2,
  deleteBonusV2,
  addBonusV2,
  submitRaffleDecision,
  editRaffleV2,
  deleteRaffleV2,
  addRaffleV2,
  submitPointDecision,
} from '../../../redux/actions/employeeSessionV2';
import {
  sessionDataSelector,
  loadingSessionReportsSelector,
  localDecisionsSelector,
} from '../../../redux/selectors/employeeSessionV2';
import ShiftDetail from '../../employeeSession/reports/ShiftDetail';
import BonusDetail from '../../employeeSession/reports/BonusDetail';
import RaffleDetail from '../../employeeSession/reports/RaffleDetail';
import PointsDetail from '../../employeeSession/reports/PointsDetail';
import { deriveAssignedDay } from '../../employeeSession/screens/EmployeeSessionsScreen';
import { TOKENS, formatHoursWorked } from '../../employeeSession/theme';
import { listRules } from '../../../redux/actions/settings';
import AuthUtil from '../../../redux/AuthUtil';
import { MACHINE } from '../../global/Server/endpoints';
import {
  availableEmployeeSelector,
  loadingSelector,
  loadStartedSessionSelector,
  machineSelector,
  readingSelector,
  categorySelector,
  manageBonusSelector,
  rulesSelector,
} from '../../../redux/selectors/settings';
import { ADD_MACHINE_READING } from './constants';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Box,
  Card,
  CardContent,
  CardActions,
  Typography,
  Divider,
  Button as MuiButton,
  Backdrop,
  Tabs,
  Tab,
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import RestoreIcon from '@mui/icons-material/Restore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import VideogameAssetOutlinedIcon from '@mui/icons-material/VideogameAssetOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import Chip from '@material-ui/core/Chip';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../../redux/actions/ticketOut';
import { globalPDFPreviewReadySelector } from '../../../redux/selectors/ticketOut';
import Utils from '../../Utils/Utils';
import { DEFAULT_PDF_ZOOM } from '../../raffle/constants';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { BACK } from '../masterReading/constants';
import { GetApp } from '@material-ui/icons';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import CustomToolbar from '../../global/CustomToolbar';
import RenderPurchaseOrderPDFPreview from '../../transaction/RenderPurchaseOrderPDFPreview';
import PrintIcon from '@mui/icons-material/Print';

class MasterRecordForm extends React.Component {
  constructor(props) {
    super(props);
    this.inInputRef = React.createRef();
    this.initialState = {
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      machine: '',
      in: '',
      out: '',
      error: '',
      sessionId: '',
      sessionStarted: false,
      machineError: false,
      inError: false,
      outError: false,
      selectedEmployeeSessionIds: [],
      sessions: [],
      requiredList: ['machine', 'in', 'out'],
      readings: [],
      previousInAndOut: null,
      //report
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,

      // V2 shift report (interactive ShiftDetail) opened from a session chip
      showShiftDetail: false,
      shiftDetailTarget: null,
      // Which report the opened session shows: 'shift' | 'bonus' | 'raffle'.
      // Bonus/Raffle expose the full audit flow so the reading guy can review
      // without leaving Master Reading.
      shiftReportTab: 'shift',
      // Per-session pending-audit counts, keyed by clockId, from
      // /machine/auditStatus. Drives the "needs audit" chip indicators.
      auditStatus: {},

      lastSessions: [], // store last two sessions
      openingSessionId: null, // track which session is being opened
      loading: false,
      canCancel: false,

      // recovery "mini safe" — cancelled sessions recoverable within 24h
      deletedSessions: [],
      restoreTargetId: null, // deletedId pending restore confirm
      restoringId: null, // deletedId currently being restored
      deleteForeverTargetId: null, // deletedId pending delete-forever confirm
      deletingForeverId: null, // deletedId currently being permanently deleted
      confirmTypedText: '', // type-to-confirm input for destructive dialogs (cancel/deleteForever)
    };

    this.state = { ...this.initialState };
  }

  componentDidMount() {
    const { selectedLocationId } = this.props.userInfo;
    this.props.availableEmployeeSessions({ locationId: selectedLocationId });
    this.props.listMachine(selectedLocationId);
    this.props.resetReading();
    this.props.loadStartedSession({ locationId: selectedLocationId });
    this.fetchLastSessions();
    this.fetchDeletedSessions();
    // Lookup data the V2 ShiftDetail uses to enrich transaction rows
    // (customer/employee names, categories, bonus types).
    this.props.getEmployees({ locationId: selectedLocationId });
    this.props.listAllCustomers({ locationId: selectedLocationId });
    this.props.listManageBonus({ locationId: selectedLocationId });
    this.props.listCategory({ locationId: selectedLocationId });
    // Rule carries enableAuditVerification — used to nudge the reading guy to
    // finish bonus/raffle audits before closing.
    this.props.listRules({ locationId: selectedLocationId });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { selectedLocationId } = this.props.userInfo;

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }

    // when employee sessions are loaded, then call loadStartedSession
    if (
      prevProps.availableSessions !== this.props.availableSessions &&
      this.props.availableSessions.length > 0
    ) {
      this.props.loadStartedSession({ locationId: selectedLocationId });
    }

    // The rule (enableAuditVerification) can arrive after the sessions are
    // already selected — refresh the audit status once it does.
    if (prevProps.rules !== this.props.rules) {
      this.fetchAuditStatus();
    }

    // when loadSession updates, update state
    if (prevProps.loadSession !== this.props.loadSession) {
      const { loadSession, availableSessions } = this.props;

      const selectedSessions = (loadSession.session?.clockSessionIds ?? [])
        .map((id) => availableSessions.find((s) => s.clockId === id))
        .filter(Boolean);

      this.setState(
        {
          sessionStarted: loadSession.sessionStarted,
          sessionId: loadSession.sessionId,
          readings: loadSession.readings,
          sessions: selectedSessions,
          selectedEmployeeSessionIds: selectedSessions.map((s) => s.clockId),
          canCancel: loadSession.canCancel || false,
        },
        () => {
          this.props.listReport({
            sessionIds: [loadSession.sessionId],
            locationId: this.props.userInfo.selectedLocationId,
          });
          this.fetchAuditStatus();
        }
      );
    }
  }

  fetchLastSessions = () => {
    const { selectedLocationId } = this.props.userInfo;
    // Backend should return last two sessions for this location
    this.props.getSessionReading(
      { locationId: selectedLocationId },
      (success, data) => {
        if (success && Array.isArray(data)) {
          this.setState({ lastSessions: data });
        } else {
          this.openFeedbackBar(
            'error',
            data || 'Failed to fetch last sessions'
          );
        }
      }
    );
  };

  // Destructive confirm dialogs require the user to type a keyword before the
  // confirm button enables, to prevent accidental cancel/permanent-delete.
  // Returns the required keyword (e.g. 'DELETE') or null if no typing is needed.
  confirmKeywordFor = (type) => {
    if (type === 'cancel' || type === 'deleteForever') return 'DELETE';
    return null;
  };

  // True when the confirm dialog can proceed: either it's not a type-to-confirm
  // dialog, or the typed text matches the required keyword (case-insensitive).
  isConfirmTypedOk = () => {
    const keyword = this.confirmKeywordFor(this.state.confirmDialogType);
    if (!keyword) return true;
    return (this.state.confirmTypedText || '').trim().toUpperCase() === keyword;
  };

  // Run the action behind the confirm dialog. Guarded so type-to-confirm
  // dialogs cannot proceed until the keyword has been typed correctly.
  handleConfirmDialogProceed = () => {
    const type = this.state.confirmDialogType;
    if (this.confirmKeywordFor(type) && !this.isConfirmTypedOk()) return;
    this.setState({ confirmDialogOpen: false, confirmTypedText: '' }, () => {
      if (type === 'start') {
        this.handleStartSessionConfirmed();
      } else if (type === 'lastSession') {
        this.handleOpenLastReadingSession();
      } else if (type === 'end') {
        this.handleEndSessionConfirmed();
      } else if (type === 'cancel') {
        this.handleCancelSessionConfirmed();
      } else if (type === 'restore') {
        this.handleRestoreConfirmed();
      } else if (type === 'deleteForever') {
        this.handleDeleteForeverConfirmed();
      }
    });
  };

  fetchDeletedSessions = () => {
    // Gate the recovery surface with the same check used to enable reopening
    // the last sessions — managers must not see or use it.
    if (!this.userIsAnMasterAdmin()) return;
    const { selectedLocationId } = this.props.userInfo;
    this.props.listDeletedReadingSessions(
      { locationId: selectedLocationId },
      (success, data) => {
        if (success && Array.isArray(data)) {
          this.setState({ deletedSessions: data });
        }
      }
    );
  };

  handleRestoreConfirmed = () => {
    if (this.state.loading) return;
    const deletedId = this.state.restoreTargetId;
    if (!deletedId) return;

    this.setState({ loading: true, restoringId: deletedId });

    const { selectedLocationId } = this.props.userInfo;

    this.props.restoreReadingSession(
      { locationId: selectedLocationId, deletedId },
      (success, message) => {
        this.setState({
          loading: false,
          restoringId: null,
          restoreTargetId: null,
        });
        if (!success) {
          this.openFeedbackBar('error', message);
        } else {
          this.openFeedbackBar('success', message);
          // Refresh everything: the recovered session becomes the active one.
          this.props.loadStartedSession({ locationId: selectedLocationId });
          this.fetchLastSessions();
          this.fetchDeletedSessions();
        }
      }
    );
  };

  handleDeleteForeverConfirmed = () => {
    if (this.state.loading) return;
    const deletedId = this.state.deleteForeverTargetId;
    if (!deletedId) return;

    this.setState({ loading: true, deletingForeverId: deletedId });

    const { selectedLocationId } = this.props.userInfo;

    this.props.deleteForeverReadingSession(
      { locationId: selectedLocationId, deletedId },
      (success, message) => {
        this.setState({
          loading: false,
          deletingForeverId: null,
          deleteForeverTargetId: null,
        });
        if (!success) {
          this.openFeedbackBar('error', message);
        } else {
          this.openFeedbackBar('success', message);
          this.fetchDeletedSessions();
        }
      }
    );
  };

  formatSafeDate = (value) => {
    if (!value) return '';
    try {
      const d = new Date(value);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleString();
    } catch (e) {
      return '';
    }
  };

  // Human "time left" until the 24h recovery window closes.
  formatExpiresIn = (expiresAt) => {
    if (!expiresAt) return null;
    const end = new Date(expiresAt).getTime();
    if (isNaN(end)) return null;
    const diff = end - Date.now();
    if (diff <= 0) return 'Expiring now';
    const hours = Math.floor(diff / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    return hours > 0 ? `${hours}h ${minutes}m left` : `${minutes}m left`;
  };

  renderMetaRow = (icon, label, value) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box
        sx={{
          display: 'flex',
          color: 'text.disabled',
          '& svg': { fontSize: 18 },
        }}
      >
        {icon}
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary', flexGrow: 1 }}>
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: 'text.primary', textAlign: 'right' }}
      >
        {value}
      </Typography>
    </Box>
  );

  renderDeletedSessionCard = (d) => {
    const busy =
      this.state.restoringId !== null || this.state.deletingForeverId !== null;
    const expiresIn = this.formatExpiresIn(d.expiresAt);

    return (
      <Card
        key={d.deletedId}
        elevation={0}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          transition:
            'box-shadow .2s ease, border-color .2s ease, transform .2s ease',
          '&:hover': {
            boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
            borderColor: 'primary.light',
            transform: 'translateY(-2px)',
          },
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 2.5 }, pb: 1.5, flexGrow: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 2,
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: '1.05rem',
                color: 'text.primary',
              }}
            >
              Session #{d.readingSessionId}
            </Typography>
            <Box
              component="span"
              sx={{
                px: 1,
                py: '2px',
                borderRadius: '6px',
                fontSize: '0.68rem',
                fontWeight: 700,
                letterSpacing: '0.04em',
                textTransform: 'uppercase',
                color: '#c62828',
                bgcolor: 'rgba(198,40,40,0.10)',
              }}
            >
              {d.reason || 'Cancelled'}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
            {this.renderMetaRow(
              <VideogameAssetOutlinedIcon />,
              'Machine readings',
              d.machineCount
            )}
            {this.renderMetaRow(
              <PersonOutlineIcon />,
              'Employee sessions',
              d.employeeCount
            )}
            {this.renderMetaRow(
              <PersonOutlineIcon />,
              'Deleted by',
              d.deletedByName || '—'
            )}
            {this.renderMetaRow(
              <AccessTimeIcon />,
              'Deleted at',
              this.formatSafeDate(d.deletedAt) || '—'
            )}
          </Box>

          {expiresIn && (
            <Box
              sx={{
                mt: 2,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.25,
                py: 0.5,
                borderRadius: '999px',
                bgcolor: 'rgba(237,108,2,0.10)',
                color: '#ed6c02',
                fontSize: '0.75rem',
                fontWeight: 600,
                '& svg': { fontSize: 16 },
              }}
            >
              <TimerOutlinedIcon />
              {expiresIn}
            </Box>
          )}
        </CardContent>

        <Divider />

        <CardActions
          sx={{
            p: { xs: 1.5, sm: 2 },
            gap: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            '& > button': { m: 0 },
          }}
        >
          <MuiButton
            fullWidth
            variant="contained"
            disableElevation
            startIcon={
              this.state.restoringId === d.deletedId ? null : <RestoreIcon />
            }
            disabled={busy}
            onClick={() =>
              this.setState({
                confirmDialogOpen: true,
                confirmDialogType: 'restore',
                restoreTargetId: d.deletedId,
                deleteForeverTargetId: null,
                openingSessionId: null,
              })
            }
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            {this.state.restoringId === d.deletedId ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              'Recover'
            )}
          </MuiButton>
          <MuiButton
            fullWidth
            variant="outlined"
            color="error"
            startIcon={
              this.state.deletingForeverId === d.deletedId ? null : (
                <DeleteForeverIcon />
              )
            }
            disabled={busy}
            onClick={() =>
              this.setState({
                confirmDialogOpen: true,
                confirmDialogType: 'deleteForever',
                deleteForeverTargetId: d.deletedId,
                restoreTargetId: null,
                openingSessionId: null,
              })
            }
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
            }}
          >
            {this.state.deletingForeverId === d.deletedId ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              'Delete Forever'
            )}
          </MuiButton>
        </CardActions>
      </Card>
    );
  };

  renderRecoverySafe = () => {
    if (this.state.sessionStarted) return null;
    if (!this.userIsAnMasterAdmin()) return null;
    if (
      !this.state.deletedSessions ||
      this.state.deletedSessions.length === 0
    ) {
      return null;
    }

    return (
      <Box sx={{ mt: 4, px: { xs: 2, sm: '20px' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Inventory2OutlinedIcon sx={{ color: 'text.secondary' }} />
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1rem', sm: '1.15rem' },
              color: 'text.primary',
            }}
          >
            Recovery Safe
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{ color: 'text.secondary', mt: 0.5, mb: 2.5 }}
        >
          Cancelled reading sessions can be recovered within 24 hours before
          they are permanently removed.
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(auto-fill, minmax(320px, 1fr))',
            },
          }}
        >
          {this.state.deletedSessions.map((d) =>
            this.renderDeletedSessionCard(d)
          )}
        </Box>
      </Box>
    );
  };

  handleOpenReadingSession = (sessionId) => {
    // open confirm dialog
    this.setState({
      confirmDialogOpen: true,
      confirmDialogType: 'lastSession',
      openingSessionId: sessionId,
    });
  };

  handleOpenLastReadingSession = () => {
    if (this.state.loading) return; // Guard

    // Frontend race guard: refuse to reopen if another session is already active.
    if (this.props.loadSession && this.props.loadSession.sessionStarted) {
      this.openFeedbackBar(
        'error',
        `Reading session #${this.props.loadSession.sessionId} is already open at this location. End or cancel it before reopening another.`
      );
      this.setState({ openingSessionId: null, confirmDialogOpen: false });
      return;
    }

    this.setState({ loading: true });

    const { selectedLocationId } = this.props.userInfo;
    const { openingSessionId } = this.state;

    this.props.openLastSessionReading(
      { locationId: selectedLocationId, sessionId: openingSessionId },
      (success, message) => {
        this.setState({ loading: false, openingSessionId: null });
        if (!success) {
          this.openFeedbackBar('error', message);
        } else {
          this.openFeedbackBar('success', message);
          window.location.reload();
        }
      }
    );
  };

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  // Open the interactive V2 shift report for a clicked employee-session chip
  // (mirrors the Weekly Report "Readings" tab). Loads the session data and
  // shows ShiftDetail inline instead of the legacy PDF preview.
  handleViewShiftReport = (option) => {
    const cr = option?.clockRecord || {};
    const userId = cr.userId;
    const locationId = cr.locationId || this.props.userInfo.selectedLocationId;
    const clockId = cr.clockId || option?.clockId;
    if (!userId || !locationId || !clockId) {
      this.openFeedbackBar(
        'error',
        'Cannot open shift report for this session'
      );
      return;
    }
    this.props.loadSessionReports({ userId, locationId, clockId });
    this.setState({
      showShiftDetail: true,
      shiftReportTab: 'shift',
      shiftDetailTarget: {
        userId,
        locationId,
        clockId,
        // Employee name only — all time/date/session fields come from
        // sessionData once loaded, so the header matches the Weekly Report's
        // shift view exactly (time-only In/Out, session #, date).
        userName: cr.name,
      },
    });
  };

  closeShiftDetail = () => {
    this.props.clearSessionReports();
    this.setState({ showShiftDetail: false, shiftDetailTarget: null });
    // The reading guy may have just audited items — refresh the per-session
    // status so the chip indicators update.
    this.fetchAuditStatus();
  };

  // Pull pending bonus/raffle audit counts for the currently selected
  // employee sessions so the chips can flag which employee still needs
  // review. Only meaningful when the audit-verification rule is on.
  fetchAuditStatus = () => {
    const auditRequired =
      (this.props.rules || [])[0]?.enableAuditVerification === true;
    const ids = this.state.selectedEmployeeSessionIds;
    if (!auditRequired || !ids || ids.length === 0) {
      this.setState({ auditStatus: {} });
      return;
    }
    AuthUtil.postRequest(MACHINE.AUDIT_STATUS, {
      locationId: this.props.userInfo.selectedLocationId,
      employeeSessionIds: ids,
    })
      .then((res) => {
        if (res.data && res.data.success) {
          const map = {};
          (res.data.sessions || []).forEach((s) => {
            map[s.clockId] = s;
          });
          this.setState({ auditStatus: map });
        }
      })
      .catch(() => {});
  };

  // Context every V2 bonus/raffle mutation + decision needs. Mirrors
  // EmployeeSession.sessionContext but sourced from the opened chip's target.
  shiftSessionContext = () => {
    const t = this.state.shiftDetailTarget || {};
    const u = this.props.userInfo || {};
    return {
      sessionId: t.clockId,
      clockId: t.clockId,
      userId: t.userId,
      locationId: t.locationId || u.selectedLocationId,
      modifiedBy: u.userId,
      modifiedByName: u.displayName || u.firstname || u.username,
    };
  };

  onAuditComplete = (message) => {
    this.openFeedbackBar('success', message || 'Audit completed');
  };

  // ── Bonus audit/edit handlers ─────────────────────────────────────────
  onSubmitBonusDecision = (bonus, decision) => {
    this.props.submitBonusDecision({
      ...this.shiftSessionContext(),
      bonusId: bonus.bonusId,
      decision,
    });
  };
  onEditBonus = (bonus, edits) => {
    this.props.editBonusV2({
      ...this.shiftSessionContext(),
      bonusId: bonus.bonusId,
      ...edits,
    });
  };
  onDeleteBonus = (bonus) => {
    this.props.deleteBonusV2({
      ...this.shiftSessionContext(),
      bonusId: bonus.bonusId,
    });
  };
  onAddBonus = (entry) => {
    this.props.addBonusV2({ ...this.shiftSessionContext(), ...entry });
  };

  // ── Points audit handler ──────────────────────────────────────────────
  onSubmitPointDecision = (point, decision) => {
    this.props.submitPointDecision({
      ...this.shiftSessionContext(),
      pendingId: point.pendingId,
      decision,
    });
  };

  // ── Raffle audit/edit handlers ────────────────────────────────────────
  onSubmitRaffleDecision = (raffle, decision) => {
    this.props.submitRaffleDecision({
      ...this.shiftSessionContext(),
      raffleId: raffle.raffleId,
      decision,
    });
  };
  onEditRaffle = (raffle, edits) => {
    this.props.editRaffleV2({
      ...this.shiftSessionContext(),
      raffleId: raffle.raffleId,
      ...edits,
    });
  };
  onDeleteRaffle = (raffle) => {
    this.props.deleteRaffleV2({
      ...this.shiftSessionContext(),
      raffleId: raffle.raffleId,
    });
  };
  onAddRaffle = (entry) => {
    this.props.addRaffleV2({ ...this.shiftSessionContext(), ...entry });
  };

  // Inline V2 shift report: a rich header (employee, session #, in/out, day)
  // plus the read-only ShiftDetail surface. Falls back to the metadata the
  // backend returns on sessionData once it matches the clicked session.
  renderShiftDetail = () => {
    const target = this.state.shiftDetailTarget || {};
    const { sessionData, loadingSessionReports } = this.props;
    const matched =
      sessionData &&
      sessionData.sessionId === target.clockId &&
      sessionData.userId === target.userId;
    const meta = matched
      ? {
          userName: target.userName || sessionData.employeeName,
          sessionNumber: sessionData.sessionNumber,
          date: sessionData.date,
          timeIn: target.timeIn || sessionData.clockIn,
          timeOut: sessionData.clockOut,
        }
      : {
          userName: target.userName,
          timeIn: target.timeIn,
        };
    const hoursLabel = matched
      ? formatHoursWorked(sessionData.hoursWorked)
      : null;
    const slashDate = (meta.date || '').replace(/-/g, '/');
    const dayLabel = deriveAssignedDay({
      timeIn:
        slashDate && meta.timeIn
          ? `${slashDate} ${meta.timeIn}`
          : meta.timeIn || slashDate || undefined,
    });

    // Pending-audit counts for the opened session (active bonuses/raffles
    // without a recorded decision). Drives the tab badges + the banner.
    const decisions = this.props.localDecisions || {};
    const bonuses = matched
      ? (sessionData.bonuses || []).filter((b) => b.status !== 'deleted')
      : [];
    const raffles = matched
      ? (sessionData.raffles || []).filter((r) => r.status !== 'deleted')
      : [];
    // Point entries are audited only when they carry a photo (VIP-match or
    // Points Watching), matching the server-side endSession gate.
    const points = matched
      ? (sessionData.points || []).filter((p) => p.hasPhoto)
      : [];
    const pendingBonus = bonuses.filter(
      (b) => !decisions[`BONUS:${b.bonusId}`]
    ).length;
    const pendingRaffle = raffles.filter(
      (r) => !decisions[`RAFFLE:${r.raffleId}`]
    ).length;
    const pendingPoint = points.filter(
      (p) => !decisions[`POINT:${p.pendingId}`]
    ).length;
    const auditRequired =
      (this.props.rules || [])[0]?.enableAuditVerification === true;
    const tab = this.state.shiftReportTab;
    // Reading guys verify only — no Manager Edit Mode on their audit surface.
    const isReadingGuy = (this.props.userInfo?.authority || []).includes(
      'ROLE_READING_GUY'
    );

    return (
      <React.Fragment>
        <Box sx={{ px: 2, pt: 1.5, maxWidth: 760, mx: 'auto', width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 1.5,
                background: TOKENS.blue50,
                border: `1px solid ${TOKENS.blue200}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <DescriptionIcon sx={{ color: TOKENS.blue700, fontSize: 26 }} />
            </Box>
            <Box>
              <Typography
                sx={{ fontSize: 20, fontWeight: 700, color: TOKENS.slate900 }}
              >
                {meta.userName || 'Shift Report'}
              </Typography>
              <Typography sx={{ fontSize: 13, color: TOKENS.slate500 }}>
                Session #{meta.sessionNumber || '—'}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 1,
              mt: 1.25,
            }}
          >
            {this.renderHeaderPill(
              dayLabel,
              TOKENS.blue50,
              TOKENS.blue700,
              TOKENS.blue200
            )}
            {this.renderHeaderPill(
              `In: ${meta.timeIn || '—'}`,
              TOKENS.emerald50,
              TOKENS.emerald700,
              TOKENS.emerald200
            )}
            {this.renderHeaderPill(
              `Out: ${meta.timeOut || 'Active'}`,
              meta.timeOut ? TOKENS.red50 : TOKENS.slate50,
              meta.timeOut ? TOKENS.red700 : TOKENS.slate500,
              meta.timeOut ? TOKENS.red200 : TOKENS.slate200
            )}
            {meta.date &&
              this.renderHeaderPill(
                meta.date,
                TOKENS.slate50,
                TOKENS.slate500,
                TOKENS.slate200
              )}
            {hoursLabel &&
              this.renderHeaderPill(
                `${hoursLabel} worked`,
                TOKENS.amber50,
                TOKENS.amber700,
                TOKENS.amber200
              )}
          </Box>
        </Box>
        {/* Audit-required nudge: tells the reading guy what's left and where
            to do it, so closing the session isn't blocked unexpectedly. */}
        {matched &&
          auditRequired &&
          pendingBonus + pendingRaffle + pendingPoint > 0 && (
            <Box sx={{ px: 2, maxWidth: 760, mx: 'auto', width: '100%' }}>
              <Box
                sx={{
                  mt: 1.5,
                  p: 1.5,
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1,
                  background: TOKENS.amber50,
                  border: `1px solid ${TOKENS.amber200}`,
                  borderRadius: 2,
                }}
              >
                <WarningAmberIcon
                  sx={{ color: TOKENS.amber700, fontSize: 20, mt: '1px' }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 700,
                      color: TOKENS.amber900,
                    }}
                  >
                    Audit required before closing this session
                  </Typography>
                  <Typography sx={{ fontSize: 12, color: TOKENS.amber900 }}>
                    {[
                      pendingBonus > 0 &&
                        `${pendingBonus} bonus${pendingBonus > 1 ? 'es' : ''}`,
                      pendingRaffle > 0 &&
                        `${pendingRaffle} raffle${
                          pendingRaffle > 1 ? 's' : ''
                        }`,
                      pendingPoint > 0 &&
                        `${pendingPoint} point ${
                          pendingPoint > 1 ? 'entries' : 'entry'
                        }`,
                    ]
                      .filter(Boolean)
                      .join(', ')}
                    {' still need review. Use the '}
                    <strong>Bonus</strong> / <strong>Raffle</strong> /{' '}
                    <strong>Points</strong> tabs below to approve or flag each
                    one.
                  </Typography>
                </Box>
              </Box>
            </Box>
          )}

        <Box
          sx={{
            px: 2,
            maxWidth: 760,
            mx: 'auto',
            width: '100%',
            mt: 1,
            borderBottom: `1px solid ${TOKENS.slate200}`,
          }}
        >
          <Tabs
            value={tab}
            onChange={(e, v) => this.setState({ shiftReportTab: v })}
            variant="fullWidth"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab value="shift" label="Shift" />
            <Tab
              value="bonus"
              label={
                auditRequired && pendingBonus > 0
                  ? `Bonus • ${pendingBonus}`
                  : 'Bonus'
              }
            />
            <Tab
              value="raffle"
              label={
                auditRequired && pendingRaffle > 0
                  ? `Raffle • ${pendingRaffle}`
                  : 'Raffle'
              }
            />
            <Tab
              value="points"
              label={
                auditRequired && pendingPoint > 0
                  ? `Points • ${pendingPoint}`
                  : 'Points'
              }
            />
          </Tabs>
        </Box>

        {!matched || loadingSessionReports ? (
          <Backdrop
            open
            sx={{
              position: 'relative',
              minHeight: 240,
              color: '#1976d2',
              background: 'transparent',
            }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <Box sx={{ px: 2, maxWidth: 760, mx: 'auto', width: '100%' }}>
            {tab === 'shift' && (
              <ShiftDetail
                readOnly
                session={null}
                sessionData={sessionData}
                customers={this.props.customers}
                employees={this.props.employees}
                categories={this.props.categories}
                manageBonusList={this.props.manageBonusList}
              />
            )}
            {tab === 'bonus' && (
              <BonusDetail
                session={null}
                sessionData={sessionData}
                customers={this.props.customers}
                manageBonusList={this.props.manageBonusList}
                onEditBonus={this.onEditBonus}
                onDeleteBonus={this.onDeleteBonus}
                onAddBonus={this.onAddBonus}
                onSubmitDecision={this.onSubmitBonusDecision}
                onAuditComplete={this.onAuditComplete}
                forceAuditTracker={auditRequired}
                hideEditMode={isReadingGuy}
              />
            )}
            {tab === 'raffle' && (
              <RaffleDetail
                session={null}
                sessionData={sessionData}
                customers={this.props.customers}
                onEditRaffle={this.onEditRaffle}
                onDeleteRaffle={this.onDeleteRaffle}
                onAddRaffle={this.onAddRaffle}
                onSubmitDecision={this.onSubmitRaffleDecision}
                onAuditComplete={this.onAuditComplete}
                hideEditMode={isReadingGuy}
              />
            )}
            {tab === 'points' && (
              <PointsDetail
                sessionData={sessionData}
                onSubmitDecision={this.onSubmitPointDecision}
                onAuditComplete={this.onAuditComplete}
                forceAuditTracker={auditRequired}
              />
            )}
          </Box>
        )}
      </React.Fragment>
    );
  };

  // Small rounded pill used in the shift-report header (matches the Employee
  // Session report screen + the Weekly Report shift view).
  renderHeaderPill = (label, bg, color, border) => (
    <Box
      sx={{
        height: 22,
        px: 1,
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '11px',
        fontSize: 12,
        fontWeight: 700,
        textTransform: 'uppercase',
        background: bg,
        color,
        border: `1px solid ${border}`,
      }}
    >
      {label}
    </Box>
  );

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.user.firstname} Report - ${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  renderTable = () => {
    if (this.state.readings.length === 0) return null;

    const sortedReadings = [...this.state.readings].sort(
      (a, b) => parseInt(a.machine, 10) - parseInt(b.machine, 10)
    );

    return (
      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead component={Paper} sx={{ mt: 3, boxShadow: 1 }}>
            <TableRow sx={{ color: '#000' }}>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                Machine
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                PrevIn
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                PrevOut
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                CurIn
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                CurOut
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                In
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                Out
              </TableCell>
              <TableCell
                sx={{ color: '#000', fontWeight: 'bold', textAlign: 'left' }}
              >
                Difference
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedReadings.map((r, idx) => {
              return (
                <TableRow
                  key={idx}
                  style={{
                    backgroundColor:
                      r.difference < 0
                        ? 'lightcoral'
                        : r.difference === 0
                        ? '#f4f4f4'
                        : 'lightgreen',
                  }}
                >
                  <TableCell>{r.machine}</TableCell>
                  <TableCell>{r.prevIn}</TableCell>
                  <TableCell>{r.prevOut}</TableCell>
                  <TableCell>{r.curIn}</TableCell>
                  <TableCell>{r.curOut}</TableCell>
                  <TableCell>{r.inValue}</TableCell>
                  <TableCell>{r.outValue}</TableCell>
                  <TableCell>{r.difference}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    // Allow only digits, +, - symbols
    const sanitizedValue = value.replace(/[^0-9+-]/g, '');
    this.setState({ [name]: sanitizedValue });
  };

  handleMachineBlur = () => {
    const { machine } = this.state;

    if (!machine) {
      this.setState({ previousInAndOut: null });
      return;
    }

    const callback = (success, data) => {
      if (!success) {
        setTimeout(() => {
          this.openFeedbackBar('error', data);
        }, 100); // delay slightly to avoid conflict with blur
        this.setState({ previousInAndOut: null });
      } else {
        this.setState({ previousInAndOut: data });
      }
    };

    this.props.getPrevInAndOut(
      { locationId: this.props.userInfo.selectedLocationId, machine },
      callback
    );
  };

  handleBlur = (event) => {
    const { name, value } = event.target;
    try {
      // Only evaluate valid math expressions (digits and operators)
      if (/^[0-9+\-*/.]+$/.test(value)) {
        // eslint-disable-next-line no-eval
        const result = eval(value);
        if (!isNaN(result)) {
          this.setState({ [name]: result.toString() });
        }
      }
    } catch (e) {
      console.warn('Invalid expression', e);
    }
  };

  clearFields = () => {
    this.setState({ in: '', out: '' }, () => {
      this.props.resetReading();
    });
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  handleStartSessionConfirmed = () => {
    if (this.state.loading) return;

    // Frontend race guard: refuse if our most recent loadStartedSession poll already
    // shows another session is active. The backend re-checks atomically as well.
    if (this.props.loadSession && this.props.loadSession.sessionStarted) {
      this.openFeedbackBar(
        'error',
        `Reading session #${this.props.loadSession.sessionId} is already open at this location. Only one reading session can be open at a time.`
      );
      this.setState({ confirmDialogOpen: false });
      return;
    }

    this.setState({ loading: true });
    const callback = (success, message) => {
      this.setState({ loading: false });
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.props.loadStartedSession({
          locationId: this.props.userInfo.selectedLocationId,
        });
        this.openFeedbackBar('success', 'Session started successfully.');
      }
    };

    this.props.startSession(
      {
        locationId: this.props.userInfo.selectedLocationId,
      },
      callback
    );
  };

  handleEndSessionConfirmed = () => {
    if (this.state.loading) return;

    const selectedIds = this.state.selectedEmployeeSessionIds;
    if (selectedIds.length === 0) {
      this.openFeedbackBar(
        'error',
        'Please select at least one employee session.'
      );
      return;
    }

    const allMachines = this.props.machines.map((m) => m.machine);
    const recordedMachines = (this.state.readings || []).map((r) => r.machine);
    const missingMachines = allMachines.filter(
      (m) => !recordedMachines.includes(m)
    );

    if (missingMachines.length > 0) {
      this.props.listMachine(this.props.userInfo.selectedLocationId);
      this.openFeedbackBar(
        'error',
        `Cannot end session. Missing readings for machines: ${missingMachines.join(
          ', '
        )}`
      );
      return;
    }

    this.setState({ loading: true });

    const callback = (success, message) => {
      this.setState({ loading: false });
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.openFeedbackBar('success', 'Session ended successfully.');
        this.setState({ ...this.initialState }, () => {
          const locationId = this.props.userInfo.selectedLocationId;

          // Refresh the list of last sessions
          this.fetchLastSessions();

          // Refresh started session and employee sessions
          this.props.loadStartedSession({ locationId });
          this.props.availableEmployeeSessions({ locationId });
        });
      }
    };

    this.props.endSession(
      {
        sessionId: this.state.sessionId,
        employeeSessionIds: selectedIds,
        locationId: this.props.userInfo.selectedLocationId,
      },
      callback
    );
  };

  userIsAnMasterAdmin = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return (
      roles.includes('ROLE_MASTER_ADMIN') ||
      roles.includes('ROLE_TECH_ADMIN') ||
      roles.includes('ROLE_OPEN_LAST_TWO_READINGS')
    );
  };

  handleCancelSessionConfirmed = () => {
    if (this.state.loading) return;

    this.setState({ loading: true });

    const locationId = this.props.userInfo.selectedLocationId;

    this.props.cancelSession({ locationId }, (success, message) => {
      this.setState({ loading: false });
      if (!success) {
        this.openFeedbackBar('error', message);
      } else {
        this.openFeedbackBar('success', message);

        // Refresh current session and last sessions
        this.props.loadStartedSession({ locationId });
        this.fetchLastSessions();
        // The cancelled session is now recoverable from the safe.
        this.fetchDeletedSessions();
      }
    });
  };

  render() {
    const { showPdfViewer, pdfData, scale, showShiftDetail } = this.state;
    // Whether this location's rule requires bonus/raffle audits before a
    // reading session can be closed (drives the on-screen notice + the gate).
    const auditRequired =
      (this.props.rules || [])[0]?.enableAuditVerification === true;

    let headerButtons;
    headerButtons = [];
    if (showShiftDetail) {
      headerButtons.push({
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.closeShiftDetail(),
        title: BACK,
      });
    } else if (this.state.showPdfViewer) {
      headerButtons.push(
        {
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.closePdfViewer(),
          title: BACK,
        },
        {
          icon: <GetApp />,
          handler: () => this.download(),
          title: 'Download PDF',
        },
        {
          icon: <PrintIcon />,
          title: 'Print PDF',
          handler: () => {
            if (!this.state.pdfData) return;
            Utils.handlePdfAction(
              this.state.pdfData,
              'print',
              'report-print.pdf'
            );
          },
        },
        {
          icon: <ZoomOutIcon />,
          handler: () => this.setZoom(-0.25),
          title: 'Zoom Out',
          disabled: false,
        },
        {
          divider: (
            <span style={{ padding: '5px', marginTop: '5px' }}>
              {this.state.scale * 100}%
            </span>
          ),
        },
        {
          icon: <ZoomInIcon />,
          handler: () => this.setZoom(0.25),
          title: 'Zoom In',
          disabled: false,
        }
      );
    }

    return (
      <React.Fragment>
        <CustomToolbar
          title={showShiftDetail ? 'Shift Report' : ADD_MACHINE_READING}
          createTitle={''}
          backTitle={''}
          headerButtons={headerButtons}
        />

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <Dialog
          open={this.state.confirmDialogOpen}
          onClose={() =>
            this.setState({
              confirmDialogOpen: false,
              openingSessionId: null,
              restoreTargetId: null,
              deleteForeverTargetId: null,
              confirmTypedText: '',
            })
          }
        >
          <DialogTitle>{'Confirm'}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {this.state.confirmDialogType === 'start'
                ? 'Do you want to start a new reading session?'
                : this.state.confirmDialogType === 'lastSession'
                ? `Do you want to reopen the previous session #${this.state.openingSessionId}?`
                : this.state.confirmDialogType === 'end'
                ? 'Do you want to end the current reading session?'
                : this.state.confirmDialogType === 'cancel'
                ? 'Do you want to cancel this session? This will remove any linked employee sessions and machine readings for this session.'
                : this.state.confirmDialogType === 'restore'
                ? 'Do you want to recover this deleted reading session? Its machine readings will be restored and it will reopen as the active session.'
                : this.state.confirmDialogType === 'deleteForever'
                ? 'Permanently delete this session from the recovery safe? This CANNOT be undone — the session and its machine readings will be gone for good.'
                : null}
            </DialogContentText>

            {this.confirmKeywordFor(this.state.confirmDialogType) && (
              <TextField
                autoFocus
                fullWidth
                margin="dense"
                variant="outlined"
                label={`Type ${this.confirmKeywordFor(
                  this.state.confirmDialogType
                )} to confirm`}
                value={this.state.confirmTypedText}
                onChange={(e) =>
                  this.setState({ confirmTypedText: e.target.value })
                }
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && this.isConfirmTypedOk()) {
                    e.preventDefault();
                    this.handleConfirmDialogProceed();
                  }
                }}
                style={{ marginTop: '12px' }}
              />
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() =>
                this.setState({
                  confirmDialogOpen: false,
                  openingSessionId: null,
                  restoreTargetId: null,
                  deleteForeverTargetId: null,
                  confirmTypedText: '',
                })
              }
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              No
            </Button>

            <Button
              variant="contained"
              disabled={this.state.loading || !this.isConfirmTypedOk()}
              onClick={this.handleConfirmDialogProceed}
              color="primary"
              style={{
                width: '100px',
                marginRight: '16px',
                marginBottom: '16px',
              }}
            >
              {this.state.loading ? <CircularProgress size={20} /> : 'Yes'}
            </Button>
          </DialogActions>
        </Dialog>

        {showShiftDetail ? (
          this.renderShiftDetail()
        ) : showPdfViewer ? (
          <RenderPurchaseOrderPDFPreview
            data={pdfData}
            handleSubmit={this.handleSubmit}
            creating={true}
            handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
            handlePdfLoadError={this.props.handlePdfLoadError}
            scale={scale}
          />
        ) : (
          <>
            {!this.state.sessionStarted && (
              <div style={{ marginTop: '24px' }}>
                <h5 style={{ marginLeft: '20px' }}>Last Two Sessions</h5>
                {this.state.lastSessions.map((session) => (
                  <Tooltip
                    key={session}
                    title={
                      !this.userIsAnMasterAdmin()
                        ? 'Only owners can reopen sessions'
                        : ''
                    }
                    arrow
                  >
                    <span>
                      <Button
                        style={{
                          marginTop: '8px',
                          minWidth: '160px',
                          height: '50px',
                          marginLeft: '20px',
                        }}
                        variant="contained"
                        color="primary"
                        disabled={
                          !this.userIsAnMasterAdmin() ||
                          this.state.openingSessionId !== null
                        }
                        onClick={() => this.handleOpenReadingSession(session)}
                      >
                        {this.state.openingSessionId === session ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          `Open Session #${session}`
                        )}
                      </Button>
                    </span>
                  </Tooltip>
                ))}
              </div>
            )}

            {!this.state.sessionStarted && (
              <div style={{ marginTop: '24px' }}>
                <h5 style={{ marginLeft: '20px' }}>Start New Session</h5>

                <Button
                  style={{
                    height: '50px',
                    marginLeft: '20px',
                    marginTop: '8px',
                  }}
                  variant="contained"
                  color="primary"
                  disabled={this.state.loading}
                  onClick={() =>
                    this.setState({
                      confirmDialogOpen: true,
                      confirmDialogType: 'start',
                    })
                  }
                >
                  {this.state.loading ? (
                    <CircularProgress size={24} />
                  ) : (
                    'Start Session'
                  )}
                </Button>
              </div>
            )}

            {this.renderRecoverySafe()}

            {this.state.sessionStarted && (
              <>
                <div
                  className="rowSpecMaster"
                  style={{
                    justifyContent: 'left',
                    alignItems: 'flex-start',
                    paddingTop: '16px',
                    gap: '20px',
                  }}
                >
                  <h3 style={{ color: 'green' }}>
                    <span role="img" aria-label="green book">
                      📗
                    </span>{' '}
                    Reading Session <strong>{this.state.sessionId}</strong> is
                    running
                  </h3>
                </div>

                {auditRequired && (
                  <Box
                    sx={{
                      mx: '20px',
                      mt: 2,
                      p: 1.25,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 1,
                      background: TOKENS.amber50,
                      border: `1px solid ${TOKENS.amber200}`,
                      borderRadius: 2,
                    }}
                  >
                    <WarningAmberIcon
                      sx={{ color: TOKENS.amber700, fontSize: 20, mt: '1px' }}
                    />
                    <Typography
                      sx={{
                        fontSize: 13,
                        color: TOKENS.amber900,
                        fontWeight: 500,
                      }}
                    >
                      <strong>Audit verification is ON.</strong> Every bonus and
                      raffle in the selected sessions must be reviewed before
                      you can end this session. Tap a session below, then use
                      its Bonus / Raffle tabs to approve or flag each one.
                    </Typography>
                  </Box>
                )}

                <div style={{ marginTop: '24px' }}>
                  <Autocomplete
                    multiple
                    style={{
                      width: window.matchMedia('(max-width: 800px)').matches
                        ? '95%'
                        : '100%',
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                    options={this.props.availableSessions}
                    getOptionLabel={(option) => option.label}
                    name="sessionIds"
                    value={this.state.sessions}
                    onChange={(event, value) => {
                      const selectedIds = value.map((item) => item.clockId);

                      this.setState(
                        {
                          sessions: value,
                          selectedEmployeeSessionIds: selectedIds,
                        },
                        () => {
                          this.props.loadStartedSession({
                            locationId: this.props.userInfo.selectedLocationId,
                            employeeSessionIds:
                              this.state.selectedEmployeeSessionIds,
                          });
                          this.fetchAuditStatus();
                        }
                      );
                    }}
                    // 👇 Make chips clickable. When audit verification is on,
                    // color each chip by its pending-audit status so the
                    // reading guy can see which employee still needs review.
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => {
                        const st = this.state.auditStatus[option.clockId];
                        const pending = st
                          ? (st.pendingBonuses || 0) +
                            (st.pendingRaffles || 0) +
                            (st.pendingPoints || 0)
                          : 0;
                        const hasItems = st
                          ? (st.totalBonuses || 0) +
                              (st.totalRaffles || 0) +
                              (st.totalPoints || 0) >
                            0
                          : false;
                        let chipStyle;
                        let label = option.label;
                        if (auditRequired && st) {
                          if (pending > 0) {
                            chipStyle = {
                              backgroundColor: TOKENS.amber50,
                              color: TOKENS.amber900,
                              border: `1px solid ${TOKENS.amber300}`,
                              fontWeight: 600,
                            };
                            label = `⚠ ${option.label} — ${pending} to audit`;
                          } else if (hasItems) {
                            chipStyle = {
                              backgroundColor: TOKENS.emerald50,
                              color: TOKENS.emerald900,
                              border: `1px solid ${TOKENS.emerald200}`,
                              fontWeight: 600,
                            };
                            label = `✓ ${option.label}`;
                          }
                        }
                        return (
                          <Chip
                            {...getTagProps({ index })}
                            key={option.clockId}
                            label={label}
                            clickable
                            style={chipStyle}
                            onClick={() => this.handleViewShiftReport(option)}
                          />
                        );
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Employee Sessions"
                        required
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        name="sessionIds"
                      />
                    )}
                  />

                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      this.state.selectedEmployeeSessionIds.length === 0 ||
                      this.state.loading
                    }
                    onClick={() =>
                      this.setState({
                        confirmDialogOpen: true,
                        confirmDialogType: 'end',
                        openingSessionId: null,
                      })
                    }
                    style={{
                      marginTop: '16px',
                      marginLeft: '20px',
                      height: '45px',
                    }}
                  >
                    {this.state.loading &&
                    this.state.confirmDialogType === 'end' ? (
                      <CircularProgress size={24} />
                    ) : (
                      'End Session'
                    )}
                  </Button>

                  {this.state.canCancel && (
                    <Button
                      variant="contained"
                      style={{
                        marginTop: '16px',
                        marginLeft: '20px',
                        height: '45px',
                        backgroundColor: 'lightgray',
                      }}
                      onClick={() => {
                        this.setState({
                          confirmDialogOpen: true,
                          confirmDialogType: 'cancel',
                          openingSessionId: null,
                        });
                      }}
                    >
                      DELETE / CANCEL
                    </Button>
                  )}
                </div>

                {this.state.previousInAndOut && (
                  <div className="master-container">
                    <div className="calculation" style={{ marginTop: '8px' }}>
                      <span>MACHINE: {this.state.machine}</span>
                    </div>

                    <div className="calculation" style={{ marginTop: '8px' }}>
                      <span>PREV IN: {this.state.previousInAndOut.prevIn}</span>
                    </div>

                    <div className="calculation" style={{ marginTop: '8px' }}>
                      <span>
                        PREV OUT: {this.state.previousInAndOut.prevOut}
                      </span>
                    </div>
                  </div>
                )}

                {this.props.reading && (
                  <div
                    className="master-container"
                    style={{
                      backgroundColor:
                        this.props.reading.difference < 0
                          ? 'lightcoral'
                          : this.props.reading.difference === 0
                          ? 'f4f4f4'
                          : 'lightgreen',
                    }}
                  >
                    <div className="calculation">
                      <span className="machine-number">
                        Machine {this.props.reading.machine}: (
                        {this.props.reading.inValue}) - (
                        {this.props.reading.outValue}) ={' '}
                        {this.props.reading.difference}
                      </span>
                    </div>

                    <div className="calculation" style={{ marginTop: '8px' }}>
                      <span>IN: {this.props.reading.curIn}</span>
                    </div>

                    <div className="calculation" style={{ marginTop: '8px' }}>
                      <span>OUT: {this.props.reading.curOut}</span>
                    </div>
                  </div>
                )}

                <div className="rowSpecMaster" style={{ marginTop: '34px' }}>
                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="Machine"
                    InputLabelProps={{ shrink: true }}
                    name="machine"
                    value={this.state.machine}
                    onChange={this.handleChange}
                    onBlur={this.handleMachineBlur}
                    required={this.state.requiredList.includes('machine')}
                    type="tel"
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      min: '0',
                      step: '1',
                    }}
                    error={this.state.machineError}
                  />

                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="In"
                    InputLabelProps={{ shrink: true }}
                    name="in"
                    value={this.state.in}
                    inputRef={this.inInputRef}
                    onChange={this.handleChange}
                    required={this.state.requiredList.includes('in')}
                    onBlur={this.handleBlur}
                    error={this.state.inError}
                    type="text"
                    inputProps={{
                      inputMode: 'tel',
                      pattern: '[0-9+-]*',
                      autoComplete: 'off',
                    }}
                  />

                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="Out"
                    InputLabelProps={{ shrink: true }}
                    name="out"
                    value={this.state.out}
                    onChange={this.handleChange}
                    required={this.state.requiredList.includes('out')}
                    onBlur={this.handleBlur}
                    error={this.state.outError}
                    type="text"
                    inputProps={{
                      inputMode: 'tel',
                      pattern: '[0-9+-]*',
                      autoComplete: 'off',
                    }}
                  />
                </div>

                <div
                  className="rowSpecMasterButton"
                  style={{ marginBottom: '24px', gap: '16px' }}
                >
                  <Button
                    variant="outlined"
                    onClick={this.clearFields}
                    className="register-new-user_btn"
                  >
                    CLEAR
                  </Button>
                  <Button
                    className="register-new-user_btn"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      const { machine } = this.state;
                      const callback = (success, message) => {
                        if (!success) {
                          this.openFeedbackBar('error', message);
                        } else {
                          this.openFeedbackBar(
                            'success',
                            'Machine reading successfully added'
                          );

                          const existingIndex = this.state.readings.findIndex(
                            (r) => r.machine === machine
                          );
                          let updatedReadings = [...this.state.readings];
                          const reading = this.props.reading;

                          if (existingIndex >= 0) {
                            // update existing machine reading
                            updatedReadings[existingIndex] = {
                              machine,
                              prevIn: reading.prevIn,
                              prevOut: reading.prevOut,
                              curIn: reading.curIn,
                              curOut: reading.curOut,
                              inValue: reading.inValue,
                              outValue: reading.outValue,
                              difference: reading.difference,
                            };
                          } else {
                            // add new reading
                            updatedReadings.push({
                              machine,
                              prevIn: reading.prevIn,
                              prevOut: reading.prevOut,
                              curIn: reading.curIn,
                              curOut: reading.curOut,
                              inValue: reading.inValue,
                              outValue: reading.outValue,
                              difference: reading.difference,
                            });
                          }

                          this.setState({
                            readings: updatedReadings,
                          });

                          this.setState(
                            (prevState) => {
                              const nextMachine = (
                                parseInt(prevState.machine, 10) + 1
                              ).toString();
                              return {
                                machine: nextMachine,
                                in: '',
                                out: '',
                                previousInAndOut: null,
                              };
                            },
                            () => {
                              const nextMachine = this.state.machine; // now safely updated
                              const callback = (success, data) => {
                                if (!success) {
                                  this.openFeedbackBar('error', data);
                                } else {
                                  this.setState({ previousInAndOut: data });
                                  if (this.inInputRef.current) {
                                    this.inInputRef.current.focus();
                                  }
                                }
                              };

                              // Dispatch the action safely
                              this.props.getPrevInAndOut(
                                {
                                  locationId:
                                    this.props.userInfo.selectedLocationId,
                                  machine: nextMachine,
                                },
                                callback
                              );
                            }
                          );
                        }
                      };
                      this.props.updateReading(
                        {
                          machine: this.state.machine,
                          in: this.state.in,
                          out: this.state.out,
                          sessionId: this.state.sessionId,
                        },
                        this.props.userInfo.selectedLocationId,
                        callback
                      );
                    }}
                    disabled={
                      this.props.loadingData ||
                      !(this.state.machine && this.state.in && this.state.out)
                    }
                  >
                    {this.props.loadingData ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      'SAVE'
                    )}
                  </Button>
                </div>
                {this.state.error && (
                  <p style={{ color: 'red' }}>{this.state.error}</p>
                )}

                {this.state.sessionStarted && (
                  <div
                    style={{
                      marginTop: '32px',
                      padding: '0 20px',
                      marginBottom: '16px',
                    }}
                  >
                    {this.renderTable()}
                  </div>
                )}
              </>
            )}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  reading: readingSelector(state),
  availableSessions: availableEmployeeSelector(state),
  loadingData: loadingSelector(state),
  loadSession: loadStartedSessionSelector(state),
  machines: machineSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  // V2 shift report
  sessionData: sessionDataSelector(state),
  loadingSessionReports: loadingSessionReportsSelector(state),
  localDecisions: localDecisionsSelector(state),
  customers: customersSelector(state),
  employees: employeesSelector(state),
  categories: categorySelector(state),
  manageBonusList: manageBonusSelector(state),
  rules: rulesSelector(state),
});

const actionCreators = {
  updateReading,
  resetReading,
  startSession,
  endSession,
  availableEmployeeSessions,
  loadStartedSession,
  listMachine,
  getPrevInAndOut,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
  listReport,
  openLastSessionReading,
  getSessionReading,
  cancelSession,
  listDeletedReadingSessions,
  restoreReadingSession,
  deleteForeverReadingSession,
  // V2 shift report
  loadSessionReports,
  clearSessionReports,
  getEmployees,
  listAllCustomers,
  listManageBonus,
  listCategory,
  listRules,
  // Bonus/Raffle/Points audit + edit from the session tabs
  submitBonusDecision,
  editBonusV2,
  deleteBonusV2,
  addBonusV2,
  submitRaffleDecision,
  editRaffleV2,
  deleteRaffleV2,
  addRaffleV2,
  submitPointDecision,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  MasterRecordForm
);
